import {
  Component,
  ElementRef,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { nextTick } from 'process';
import { isNullOrEmpty } from '../../../core/utils/common-functions';
import { EnhancedFormControl } from '../../../models/rt-common/form-config';
import { BaseComponent } from '../../../shared/components';
/**
 * 文字輸入元件
 */
@Component({
  selector: 'sigv-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss'],
})
export class InputTextComponent extends BaseComponent implements OnInit {
  /** 如有設定則會顯示於 formValidate時的錯誤訊息 */
  @Input() fieldName?: string;
  /** formControl物件
   * @description useForm.controls['externalName']
   */
  @Input() bindingFormControl?: AbstractControl | any;

  @Input() applyDifferenceDetect: boolean = false;
  @Input() beforeInputValue?: any;
  @Input() afterInputValue?: any;

  @Input() replaceNullWith?: string = '-';
  /** 空值欲設提示 */
  @Input() placeholder?: string;
  /** 欄位寬度 */
  @Input() maxlength?: number;
  /** 欄位寬度(單位) */
  @Input() maxlengthUnit?: string = 'px';
  /** 頁面是否純檢視*/
  @Input() isReadOnly: boolean = false;
  /** 是否後綴符號 */
  @Input() isPostfixMark: boolean = false;
  /**
   * 是否cust style
   */
  @Input() isCustStyle: boolean = false;
  /** 只允許數字 */
  @Input() numberOnly: boolean = false;
  /** 資料型態是否為 number */
  @Input() dataTypeIsNumber: boolean = false;
  /**blur事件 */
  @Output() blur: EventEmitter<any> = new EventEmitter();
  /**change事件 */
  @Output() change: EventEmitter<any> = new EventEmitter();
  useWidth = '';
  constructor(injector: Injector, private el: ElementRef) {
    super(injector);
    this.useWidth = `${this.maxlength}${this.maxlengthUnit}`;
  }
  render = true;
  get useStyle() {
    return this.isPostfixMark ? 'display: inline-block' : '';
  }
  get useCustStyle() {
    return this.isCustStyle
      ? 'form-control p-inputtext p-inputtext-cust'
      : 'form-control p-inputtext';
  }
  forceRender() {
    this.render = false;
    nextTick(() => {
      this.render = true;
    });
  }
  blurEvent(event: any) {
    if (this.numberOnly) {
      this.validateValue();
    }
    this.blur.emit(event);
  }
  changeEvent(event: any) {
    this.change.emit(event);
  }
  ngOnInit() {
    this.logger.debug(
      'input-text init',
      ' bindingFormControl:',
      this.bindingFormControl
    );
    this.useWidth = `${String(this.maxlength)}${this.maxlengthUnit}`;
    if (this.isReadOnly) {
      if (this.beforeInputValue instanceof EnhancedFormControl) {
        const beforeValue = this.beforeInputValue?.getRawValue();
        const afterValue = this.afterInputValue?.getRawValue();

        if (beforeValue !== afterValue) {
          this.el.nativeElement.classList.add('value-diff');
        }
      } else {
        return;
      }
    }
  }
  /** 數字檢核 */
  validateValue() {
    let value = this.bindingFormControl?.getRawValue();
    if (this.dataTypeIsNumber) {
      if (isNullOrEmpty(value)) {
        value = null;
      } else {
        value = Number(value?.toString().replace(/\D+/g, ''));
      }
    } else {
      value = value?.replace(/\D+/g, '');
    }
    this.bindingFormControl.setValue(value);
  }
}
